/* eslint-disable global-require */
<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">
          IpsosCX
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="12"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <h2>{{ $t(message) }}</h2>
        </div>
      </b-col>
      <!-- /Left Text-->

    </b-row>

  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import VuexyLogo from '@core/layouts/components/Logo.vue'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { refreshMenu, periodList } from '@core/layouts/utils'
import store from '@/store/index'
import {
  BCol, BRow, BLink,
} from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BCol,
    BRow,
    VuexyLogo,
  },
  data() {
    return {
      message: 'Please wait...',
    }
  },
  computed: {
    imgUrl() {
      return this.sideImg
    },
  },
  watch: {
    $route() {
      this.checkKey()
    },
  },
  async created() {
    await this.checkKey()
  },
  methods: {
    async goto() {
      await refreshMenu()
      await periodList()
    },
    async loggedIn(data) {
      const { userData } = data.data
      useJwt.setToken(data.data.accessToken)
      useJwt.setRefreshToken(data.data.refreshToken)
      localStorage.setItem('userData', JSON.stringify(userData))
      this.$ability.update(userData.ability)

      await this.goto()
      const { menuLinks } = store.state.verticalMenu

      const firstPage = menuLinks[0]

      this.$router.push({ name: 'dashboard', params: { id: firstPage.id } })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Welcome ${userData.fullName}`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
            },
          })
        })
    },
    async checkKey() {
      this.inProgress = true

      useJwt.axiosIns.get(`user/sso/${this.$route.params.key}`)
        .then(response => {
          this.inProgress = false
          if (response.data === 'error' || response.data === '') {
            this.message = this.$t('Login failed!')
          } else {
            const legal = localStorage.getItem('legal')
            if (!legal) {
              this.$swal({
                title: this.$t('Legal Warning'),
                html: this.$t('legal'),
                width: '50%',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: this.$t('Continue'),
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              }).then(result => {
                if (result.value) {
                  localStorage.setItem('legal', true)
                  this.loggedIn(response)
                }
              })
            } else {
              this.loggedIn(response)
            }
          }
        })
        .catch(e => {
          console.log('err', e.status)
          this.inProgress = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
